/* eslint-disable camelcase */
import React, {
  useMemo,
} from 'react';
import {
  shallowEqual,
  useSelector,
} from 'react-redux';
import i18n from 'i18next';

import {
  coreSelectors,
} from '@gymcloud/core';

import {
  Flex,
} from 'web-styled';

import Tab from '../Tab';
import EmptyList from '../EmptyList';
import WorkoutIndicator from '../WorkoutIndicator';
import Table from './Table';

const mapState = (state) => {
  const { dashboard } = coreSelectors.getProfile(state);
  return {
    dashboard,
    pastWorkouts: coreSelectors.getPastWorkouts()(state),
    scheduledWorkouts: coreSelectors.getUpcomingWorkouts()(state),
  };
};

const Client = () => {
  const {
    dashboard,
    pastWorkouts,
    scheduledWorkouts,
  } = useSelector(mapState, shallowEqual);

  const tabs = useMemo(() => ([
    {
      id: 1,
      name: i18n.t('dashboard.upcoming.workouts'),
    },
    {
      id: 2,
      name: i18n.t('dashboard.completed.this.week'),
    },
  ]));

  return (
    <Flex
      column
      spacing={25}
      padding="41px 23px 54px"
      flex="1 1 0"
    >
      <WorkoutIndicator
        isClient
        text={i18n.t('dashboard.completed.this.week')}
        total={dashboard?.events_scheduled_this_week_count || 0}
        completed={dashboard?.events_completed_this_week_count || 0}
      />
      <Tab tabs={tabs}>
        {activeTab => ({
          1: (scheduledWorkouts.length > 0) ? (
            <Table
              workouts={scheduledWorkouts}
            />
          ) : (
            <EmptyList
              name="$t(workout) events"
            />
          ),
          2: (pastWorkouts.length > 0) ? (
            <Table
              withStatus
              workouts={pastWorkouts}
            />
          ) : (
            <EmptyList
              name="$t(workout) events"
            />
          ),
        }[activeTab])}
      </Tab>
    </Flex>
  );
};

export default Client;
